import HowToHeader from '../HowToHeader';
import HowToStep from '../HowToStep';

// Images
import step1Img from './Step 1 Image.png';
import step2Img from './Step 2 Image.png';
import step3Img from './Step 3 Image.png';

// Header
const headerText = `Re-uploading Information`;
const subtitleText = `In the case that your information is not uploaded correctly, or you receive a notification that
                        your application needs further action, here are the steps for how to correct and resubmit this
                        information. `;

// Steps
const step1Text = `Go to your Account Dashboard and click on the card directing you to re-upload information.`;
const step2Text = `Once you click into the message box, you will see an error about what needs to be re-uploaded
                    as well as a link to do so that says “(click here to reupload).”`;
const step3Text = `Once this process is complete, you will see a yellow box that indicates the new upload has been
                    accepted. Then proceed to click “Re-submit Application” it will ask if you are sure, at which
                    point you can finalize and submit. The original box that indicated this further action was needed
                    will disappear from the Account Dashboard. `;

const ReuploadingInformation = () => {
  return (
    <>
      <HowToHeader titleText={headerText} subtitleText={subtitleText} />
      <p>
        For example, the first image below is what you would see if you’ve
        incorrectly uploaded a document for your proof of primary residency. If
        you are needing to update other pieces of information, you will see
        messages regarding that. Follow the steps provided in order to correct
        this information.
      </p>
      <HowToStep stepNumber={1} content={step1Text} imgSrc={step1Img} />
      <HowToStep stepNumber={2} content={step2Text} imgSrc={step2Img} />
      <HowToStep stepNumber={3} content={step3Text} imgSrc={step3Img} />
    </>
  );
};

export default ReuploadingInformation;
